import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ServiceRequest } from 'fhir/r4';
import { AdmittedPatientsComponent } from '../admitted-patients/admitted-patients.component';
import { LoadingUIEnabled, SkipHospitalSegregation } from '../loading.interceptor';
import { HttpContext } from '@angular/common/http';
import { ReferenceDisplayDirective } from '../shared/reference-display.directive';
import { EmptyStateComponent } from '../shared/empty-state/empty-state.component';
import { NaPipe } from '../shared/na.pipe';
import { ChipsDirective } from '../chips.directive';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { CodeableConcept2Pipe } from '../shared/codeable-concept2.pipe';
import { PatientNamePipe } from '../shared/pipes/patient-name.pipe';
import { PatientContactsPipe } from '../shared/pipes/patient-contacts.pipe';
import { PatientAgePipe } from '../shared/pipes/patient-age.pipe';
import { PatientAddressPipe } from '../shared/pipes/patient-address.pipe';
import { UtilityService } from '../shared/utility.service';

@Component({
    selector: 'app-referral-requests',
    standalone: true,
    imports: [
        CommonModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatDividerModule,
        DatePipe,
        MatTableModule,
        MatTooltipModule,
        ReferenceDisplayDirective,
        EmptyStateComponent,
        NaPipe,
        ChipsDirective,
        TableHeaderComponent,
        CodeableConcept2Pipe
    ],
    providers: [PatientNamePipe, PatientContactsPipe, PatientAgePipe, PatientAddressPipe],
    templateUrl: './referral-requests.component.html',
    styleUrls: ['../admitted-patients/admitted-patients.component.scss', '../service-requests/service-requests.component.scss']
})
export class ReferralsComponent extends AdmittedPatientsComponent implements OnInit {
    private utility = inject(UtilityService);

    override displayedColumns = ['authoredOn', 'status', 'category', 'code', 'subject', 'action'];

    override ngOnInit() {
        this.loadReferralRequests();
    }

    loadReferralRequests() {
        const user = this.auth.user.getValue();
        const hospitalId = user?.['hospitalId'];
        if (!hospitalId) return;

        this.utility.threeTierQueryAndSyncToStateOnce$<ServiceRequest>({
            resourceType: 'ServiceRequest',
            scope: 'orgWide',
            querySearchObject: [
                { key: 'performer.reference', value: [`Organization/${hospitalId}`] },
                { key: 'status', value: ['active', 'on-hold', 'completed'] },
                { key: 'category.coding.code', value: ['referral'] }
            ],
            context: new HttpContext().set(SkipHospitalSegregation, true).set(LoadingUIEnabled, true)
        }).subscribe(requests => {
            this.tableDataSource.data = requests.map(r => ({
                ...r,
                id: r.id
            }));
        });
    }

    openRequestDocument(row: ServiceRequest) {
        if (!row.id) {
            return;
        }

        this.router.navigate(['/app', 'request-documents', row.id]);
    }
}
